import React from 'react'
import './FAQsection.css'
import Accordion from './Accordion.jsx'


function FAQsection () {
  return(
    <div className="FAQ-section">
      <div className="FAQ-section-title">
        <hr></hr>
        <h1>FAQ</h1>
        <hr></hr>
      </div>
      <div className="FAQ-section-content">

        <h2>
          LES PARCOURS
        </h2>
        <Accordion question={"Où puis-je m’inscrire pour participer au Raid?"} 
          response={<p>
            Pour participer au Raid, rien de plus simple ! Le lien de la <b>billetterie</b> est disponible sur le site. <br/>
            Assure toi de bien lire le règlement et de choisir le bon parcours et le bon tarif (Cotisant/Non cotisant BDE UTC). L’inscription se fait en équipe. Si tu n’as pas d’équipe, tu peux t’inscrire seul.e, nous te recontacterons pour t’aider à trouver un ou une partenaire ! <br/>
            Un <b>tarif Etudiant/jeune</b> est prévu ! Tu bénéficies de 5€ de réduction sur tous les parcours si tu as moins de 18 ans ou si tu es étudiant.e dans n’importe quelle école d’enseignement supérieur !
          </p>} />
        <Accordion question={"Quelles sont les conditions pour pouvoir participer au raid ?"} 
          response={<div>
            <p>Les parcours chronométrés (L'Exploration du Chevreuil Capreolus et L’Expédition du Loup Gris) sont ouverts aux participants de 16 ans ou plus. En dessous de cet âge, les participants devront être accompagnés d’une personne majeure.</p>
            <p>Pour chaque parcours chronométré un certificat médical de non‐contre‐indication à la pratique du VTT ou de la course à pied selon le parcours, émis il y a moins de deux ans est nécessaire (la pastille BDS ou une licence sportive en compétition font office de justificatif). Le certificat médical devra être déposé à l’inscription, envoyé par mail à l’adresse <b><u>raidut20@gmail.com</u></b> ou bien lors de la remise des dossards le jour-J.</p>
            <p><div class="texte-caution"><b>Pour l'Expédition du Loup Gris, il vous sera demandé un chèque de caution de 65€ à l'ordre de PAE - Raid'UT pour la location des puces de chronométrage</b></div></p>
            <p><b>L’Expédition du Loup Gris</b> d'environ 45 km se fait OBLIGATOIREMENT en vélo (VTT).</p>
            <p><b>L'Exploration du Chevreuil Capreolus </b>propose deux variantes :<ul><li>En VTT, auquel cas les participants ne sont pas chronométrés</li><li>A pieds ou Run&Bike, auquel cas les participants sont chronométrés</li></ul></p>
            <p><b>La Balade de l'Écureuil Roux</b> peut se faire à pied, ou en vélo. Dans les deux cas, ce parcours n’est pas chronométré.</p>
          </div>} />
        <Accordion question={"Combien doit-on être par équipe ?"} 
          response={<ul>
            <li><b>La Balade de l'Écureuil Roux</b> : équipes de 2 à 5</li>
            <li><b>L'Exploration du Chevreuil Capreolus</b> : équipes de 2</li>
            <li><b>L’Expédition du Loup Gris</b> : équipes de 2</li>
          </ul>} />
        <Accordion question={"A quelle heure se font les différents départs du raid ?"} 
          response={<div>
            <p>Les départs se font par vagues de 5 équipes :</p>
            <ul>
              <li><b>La Balade de l'Écureuil Roux</b> : Départ entre 12h30 et 14h30</li>
              <li><b>L'Exploration du Chevreuil Capreolus</b> : Départ entre 10h00 et 12h00</li>
              <li><b>L’Expédition du Loup Gris</b> : Départ entre 8h et 9h30</li>
            </ul>
            <p>La vague de départ de ton équipe est déterminée à l'inscription</p>
          </div>} />
        <Accordion question={"Quelles sont les différentes épreuves de chaque parcours ?"} 
          response={<p>
            Les épreuves sont <b>variées</b> et s’effectuent à pied ou à vélo ! On peut compter des épreuves de trail, de course d’orientation, et de tir, mais aussi des énigmes, et de nombreuses activités plus ludiques sur le parcours loisir. Une description détaillée de chaque parcours sera bientôt disponible dans les <b>Roadbooks</b> correspondants qui seront communiqués 2 semaines avant l'évènement.
          </p>} />
        <Accordion question={"Est-ce que je suis obligé de faire toutes les épreuves ?"} 
          response={<p>
            <p><b>Non</b> ! Le R4M est un raid accessible à toutes et à tous, il n’est donc pas obligatoire de participer à toutes les épreuves. En revanche, l'abandon d’une épreuve sur les parcours chronométrés entraînera une <b>pénalité</b> non négligeable.</p>
            <p>De plus, les épreuves sont optionnelles. La plus petite distance indiquée est la distance du parcours sans les épreuves optionnelles. Au contraire, la plus grande distance correspond à celle du parcours si ton équipe décide de participer à toutes les épreuves !</p>
          </p>} />
        <Accordion question={"Pourquoi la distance d’un parcours n’est pas fixe ?"} 
          response={<p>
            Comme expliqué plus haut, les épreuves sont <b>optionnelles</b>. La plus petite distance indiquée est la distance du parcours sans les épreuves. Au contraire, la plus grande distance correspond à celle du parcours si ton équipe décide de participer à toutes les épreuves !
          </p>} />
        <Accordion question={"Est-ce que je dois prévoir de la nourriture et de l'eau pour mon parcours ?"} 
          response={<p>
            <p>Des <b>ravitaillements</b> seront disposés à intervalles réguliers sur chaque parcours ! Ils contiendront tout ce qu’il faut pour reprendre des forces et repartir plein d’énergie ! Il est néanmoins conseillé aux participants du parcours compétition d’emporter des barres de céréales ou autres friandises en cas de fringale.</p>
            <p>En revanche, n’oubliez pas de prendre une gourde et de la remplir à chaque ravitaillement !</p>
          </p>} />
        <Accordion question={"Est-ce qu’un classement sera effectué sur les différents parcours ?"} 
          response={<div>
            <p>Trois classements à deux catégories (mixte et féminin) sont disponibles sur les parcours chronométrés :</p>
            <ul>
              <li>Classement <b>course</b> à pied de <b>L'Exploration du Chevreuil Capreolus</b></li>
              <li>Classement <b>Run&Bike</b> de <b>L'Exploration du Chevreuil Capreolus</b></li>
              <li>Classement <b>VTT</b> de <b>L’Expédition du Loup Gris</b></li>
            </ul>
            <p>Des lots sont prévus pour les équipes les plus performantes de chaque classement.</p>
          </div>}/>
               
               
        <h2>
          LE VILLAGE
        </h2>
        <Accordion question={"Est-il possible de venir sur le village sans faire le raid ?"} 
          response={<p>
            <b>Oui</b> ! Le village est ouvert à toutes et tous, <b>gratuitement</b>, durant l’ensemble de la journée. De nombreuses <b>animations</b> et <b>concerts</b> viendront agrémenter le village.
          </p>} />
        <Accordion question={"Quels sont les horaires d'ouverture ?"} 
          response={<p>
            Le village ouvre ses portes dès <b>7h30 et jusqu’à 20h</b>. L’entrée est <b>gratuite</b> et de nombreuses <b>activités</b> animeront le village toute la journée.
          </p>} />
        <Accordion question={"Est-il possible de se restaurer sur place ?"} 
          response={<p>
            <b>Oui</b> ! Il y aura un stand de restauration ainsi qu’une buvette sur le village associatif, ouverts à partir de 11h. Des repas <b>végétariens</b> seront aussi proposés. L’accès au village est totalement <b>gratuit</b> et <b>ouvert à tous et à toutes.</b>
          </p>} />
        <Accordion question={"Où puis-je poser mon vélo ?"} 
          response={<p>
            Un <b>parc à vélo</b> sera à disposition sur le village. D’autres seront disposés sur les épreuves qui le nécessitent.
          </p>} />
        <Accordion question={"Je suis intéressé(e) pour être bénévole, quelles sont les démarches à effectuer ?"} 
          response={<p>
            Déjà nous te <b>remercions</b> pour ta motivation, pour cela tu peux nous envoyer un mail à l’adresse <b><u>raidut20@gmail.com</u></b> nous te recontacterons pour te donner les informations complémentaires. <br/>
            Il est tout à fait possible d’être bénévole et de participer à un parcours.
          </p>} />
        <Accordion question={"Le Raid est-il réellement caritatif ?"} 
          response={<p>
            <b>Bien sûr</b> ! Participer au R4M c’est faire une bonne action pour la préservation de la forêt (sans forêt, pas de raid). Nous sommes en partenariat avec <b>Cœur de Forêt</b>, une association qui lutte pour cette cause et à laquelle nous reversons 2€ par place vendue sous forme de don !<br/>
            L’an dernier, nous avons récolté 850€ qui ont permis à l’association de <b>planter 106 arbres !</b>
          </p>} />

      </div>
    </div>
  )
}

export default FAQsection
